import styled from "styled-components";

export const DashboardContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: white;
  margin-top: 30px;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const MainTitle = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:30px;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const SettingWrapper = styled.div`
  justify-self: end;
`;

export const OuterWrapper = styled.div`
  padding: 1rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const DashboardWidgetContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(519px, 1fr));
  gap: 1rem;
  margin-bottom: 10px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  font-weight: normal;
  gap: ${(props) => props.gap ?? "0px"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  padding: ${(props) => props.padding ?? "0px"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;
export const NoWidget = styled.div`
  border: 2px #00aeea dashed;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  min-height: 10rem;
  border-radius: 7px;
`;

export const PlusSign = styled.div`
  font-size: 8rem;
  justify-content: center;
  display: flex;
  color: #00aeea;
  border-radius: 37rem;
  cursor: pointer;
`;

export const DashboardContainerSection = styled.section`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 2px 2px;
  background-color: white;
  padding: 15px 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  align-content: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 15px;
`;

export const CenterPagination = styled.div`
  justify-self: center;
  margin-top: 5px;
`;
